import WangEditor from 'wangeditor';
import './index.css';

export default {
  name: 'Aeditor',
  props: {
    id: { type: String, default: () => (`a-editor-${Math.random().toString().substring(2)}`) },
    value: { type: String, default: () => '' },
    placeholder: { type: String, default: () => '请输入正文...' },
    uploadUrl: { type: String, default: () => '' },
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      editor: null,
      content: '',
    }
  },
  watch: {
    value(value = undefined) {
      this.relate(value);
    }
  },
  created() {
    this.create();
  },
  destroyed() {
    this.cancel();
  },
  methods: {
    create() {
      this.content = this.value;
      this.$nextTick(() => {
        this.editor = new WangEditor(this.$refs[this.id]);
        this.$nextTick(() => {
          this.editor.config.loading = this.loading;
          this.editor.config.onchangeTimeout = 100; // 监听响应延迟
          this.editor.config.pasteIgnoreImg = false; // 忽略粘贴的图片
          this.editor.config.pasteFilterStyle = false; // 关闭样式过滤
          this.editor.config.placeholder = this.placeholder; // 输入提示
          this.editor.config.uploadImgShowBase64 = true; // 使用 base64 格式保存图片
          this.editor.config.uploadImgServer = this.uploadUrl; // 图片上传路径
          this.editor.config.onchange = this.change; // 监听输入
          this.editor.config = ({ ...this.editor.config, ...this.config }); // 追加额外配置项
          this.$nextTick(() => {
            this.editor.create(); // 创建编辑器
            this.$nextTick(() => this.editor.txt.html(this.content)); // 添加默认值
          });
        });
      });
    },
    relate(value = undefined) {
      if (this.editor) {
        if (value == undefined) {
          this.editor.txt.html('');
        } else {
          if (value != this.content) {
            this.content = value;
            this.$nextTick(() => this.editor.txt.html(this.content));
          }
        }
      }
    },
    change(a) {
      this.content = a;
      this.$nextTick(() => {
        this.$emit('input', this.content);
        this.$nextTick(() => this.$emit('change', this.content));
      });
    },
    cancel() {
      this.editor.txt.html('');
      this.$nextTick(() => {
        this.editor.destroy();
        this.$nextTick(() => this.editor = null);
      });
    },
  },
  render() {
    return (
      <div class="a-editor">
        <div id={this.id} ref={this.id} class="a-editor-main" />
        <el-input v-model={this.value} type="textarea" class="a-editor-hide" />
      </div>
    );
  },
}